import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';

async function getFluxoCaixaKpis(params): Promise<any> {
  const api = await getApi();
  const { data } = await api.get<any>('/fluxo_caixa/', {params});
  return data;
}

type QueryFnType = typeof getFluxoCaixaKpis;

function useFluxoCaixaKpis(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-fluxo-caixa', params],
    queryFn: () =>  getFluxoCaixaKpis(params),
  });
}

export { useFluxoCaixaKpis };
